import React from "react";
import ContactHero from "../components/ContactHero";
import ContactSection from "../components/ContactSection";
import ContactDemoExpectations from "../components/ContactDemoExpectations";
import ContactSocialProof from "../components/ContactSocialProof";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import ReadyToSeeDifference from "../components/ReadyToSeeDifference";

const Contact = () => {
  return (
    <div className="bg-[#fdfdfd]">
      <SEO
        title="Request a Demo | SmileReveal™ AI Smile Simulation for Dentists"
        description="Request a free personalized demo of SmileReveal™ AI smile simulation software. See how dental practices boost case acceptance to 60%+ with instant smile previews for implants, veneers, and All-on-X. Response within 1 business day."
      />
      <div
        className="relative"
        style={{
          backgroundImage: "url('/svgs/background.svg')",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        {/* Gradient fade at bottom */}
        <div className="pointer-events-none absolute bottom-0 left-0 w-full h-32 bg-gradient-to-b from-transparent to-white backdrop-blur-0 z-40"></div>

        <ContactHero />
      </div>
      <main>
        <ContactSection />
        <ContactDemoExpectations />
        <ContactSocialProof />
        <ReadyToSeeDifference />
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
